
import React from "react";
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle,
} from "@/components/ui/card";
import { CompanyList } from "@/components/companies/CompanyList";
import { Company } from "@/types";

interface CompanyCardProps {
  companies: Company[];
  isLoading: boolean;
  onEdit: (company: Company) => void;
  onDelete: (id: string) => void;
}

export const CompanyCard = ({
  companies,
  isLoading,
  onEdit,
  onDelete
}: CompanyCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Company List</CardTitle>
        <CardDescription>All companies using ShiftSage</CardDescription>
      </CardHeader>
      <CardContent>
        <CompanyList
          companies={companies}
          isLoading={isLoading}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </CardContent>
    </Card>
  );
};
